export default "__VITE_ASSET__D$ixlPK4__"